<template>
  <div>
    <DataListStateful
      title="Описания товаров"
      resource="goods-details"
      store="goodsDetails"
      :columns="columns"
      :disable-adding="true"
      :filter-options="filter"
      :row-color-fn="getRowColor"
    />
  </div>
</template>

<script>
import { eShippingStates } from "../shippings/shipping-states.js";
import lables from "../shippings/components/labels/lables.js";
export default {
  data() {
    return {
      columns: [
        { title: "Номер", name: "id", isEditLink: true, sortable: false },
        {
          title: "№ поставки",
          name: "ShippingNumber",
          dataPath: "Shipping.Number",
          sortable: true,
        },
        {
          title: "№ маршрута",
          name: "Route",
          dataPath: "Route.Number",
          sortable: false,
        },
        {
          title: "Дата создания Поставки",
          name: "ShippingDate",
          dataPath: "Shipping.Date",
          sortable: true,
        },
        {
          title: "Тип поставки",
          name: "ShippingType",
          dataPath: "Shipping.Type.Title",
          sortable: true,
        },
        {
          title: "Клиент",
          name: "Client",
          dataPath: "Shipping.Client.Title",
          sortable: true,
        },
        {
          title: "Клиент по документам",
          name: "ClientAlias",
          dataPath: "Shipping.ClientAlias",
          sortable: true,
        },
        {
          title: "Продавец",
          name: "Factory",
          dataPath: "Shipping.Factory.Title",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Производитель",
          name: "Manufacturer",
          dataPath: "Manufacturers",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Статус",
          name: "ShippingState",
          valueFn(item) {
            return item.Shipping.State;
          },
          type: "object",
          sortable: true,
        },
        {
          title: "Менеджер по описанию",
          name: "ManagerByDescription",
          dataPath: "Shipping.ManagerByDescription.Title",
          sortable: true,
        },
        {
          title: "Референс погрузки",
          name: "LoadingNumber",
          dataPath: "Shipping.LoadingNumber",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Маркировка",
          name: "FactoryMarking",
          dataPath: "FactoryMarking",
          sortable: true,
          width: 100,
          maxLength: 10,
        },
        {
          title: "Статус погрузки",
          name: "RouteState",
          dataPath: "Route.State.Title",
          sortable: true,
        },
        {
          title: "Свозка",
          name: "HasCombination",
          dataPath: "Shipping.HasCombination",
          type: "bool",
          sortable: true,
        },
        {
          title: "Дата подготовки описания",
          name: "LastChangeDate",
          dataPath: "LastChangeDate",
          type: "date",
          sortable: true,
        },
        {
          title: "Дата затаможки",
          name: "CustomsRegistrationDates",
          dataPath: "Route.CustomsRegistrationDates",
          type: "planFactDates",
          sortable: true,
        },
        {
          title: "Дата прохождения границы",
          name: "PassingBorderDates",
          dataPath: "Route.PassingBorderDates",
          type: "planFactDates",
          sortable: true,
        },
        {
          title: "Дата забора",
          name: "DeliveryToUnloadingPlaceDates",
          dataPath: "Route.DeliveryToUnloadingPlaceDates",
          type: "planFactDates",
          sortable: true,
        },
        {
          title: "EX",
          name: "EX",
          sortable: true,
          valueFn(item) {
            return `${
              lables.ex.value.exWhoDoing.variants.find(
                i => i.id === item.EX.ExWhoDoing,
              ).title
            } / ${
              item.EX.ExDocumentInSystem ? "есть в системе" : "нет в системе"
            }`;
          },
          width: "140",
          whiteSpace: true,
        },
        {
          title: "Invoice",
          name: "Invoice",
          sortable: true,
          valueFn(item) {
            if (item.Invoice) {
              return "Есть в системе";
            } else {
              return "Нет в системе";
            }
          },
        },
        {
          title: "Метка 'Описание'",
          name: "Description",
          dataPath: "Description.Title",
          sortable: true,
        },
        {
          title: "Хрупкий",
          name: "Fragile",
          dataPath: "Fragile",
          type: "bool",
          sortable: true,
        },
        {
          title: "Обмер груза",
          name: "Mesurable",
          dataPath: "Mesurable.Title",
          sortable: true,
        },
        {
          title: "Количество мест",
          name: "Places",
          dataPath: "Places",
          sortable: true,
        },
        {
          title: "Вес нетто",
          name: "TotalWeightNetto",
          dataPath: "TotalWeightNetto",
          type: "decimal",
          scale: 3,
          sortable: true,
        },
        {
          title: "Вес брутто",
          name: "TotalWeightBrutto",
          dataPath: "TotalWeightBrutto",
          type: "decimal",
          scale: 3,
          sortable: true,
        },
        {
          title: "Объем",
          name: "TotalVolume",
          dataPath: "TotalVolume",
          type: "decimal",
          scale: 3,
          sortable: true,
        },
      ],
      filter: {
        shippingNumber: {
          title: "Номер поставки",
          type: "text",
        },
        date: {
          title: "Дата",
          type: "date",
        },
        route: {
          title: "Номер маршрута",
          type: "reference",
          resource: "routes",
        },
        shippingTypes: {
          title: "Тип поставки",
          type: "enum",
          resource: "delivery-types",
        },
        client: {
          title: "Клиент",
          type: "reference",
          resource: "clients",
        },
        clientAlias: {
          title: "Клиент по документам",
          type: "text",
        },
        factory: {
          title: "Продавец",
          type: "reference",
          resource: "factories",
        },
        manufacturer: {
          title: "Производитель",
          type: "reference",
          resource: "manufacturers",
        },
        shippingStates: {
          title: "Статус",
          type: "enum",
          resource: "shipping-states",
        },
        managerByDescription: {
          title: "Менеджер по описанию",
          type: "reference",
          resource: "employees",
        },
        LoadingNumber: {
          title: "Референс погрузки",
          type: "text",
        },
        factoryMarking: {
          title: "Маркировка",
          type: "text",
        },
        routeStates: {
          title: "Статус погрузки",
          type: "enum",
          resource: "route-states",
        },
        hasCombination: {
          title: "Свозка",
          type: "bool",
        },
        lastChangeDate: {
          title: "Дата подготовки описания",
          type: "date",
        },
        customsRegistrationDateActual: {
          title: "Дата затаможки",
          type: "date",
        },
        passingBorderDateActual: {
          title: "Дата прохождения границы",
          type: "date",
        },
        deliveryToUnloadingPlaceDate: {
          title: "Дата забора",
          type: "date",
        },
        exWhoDoings: {
          title: "EX",
          type: "enum",
          resource: "shipping-ex-who-doing",
        },
        exDocumentInSystem: {
          title: "EX в системе",
          type: "bool",
        },
        invoice: {
          title: "Invoice в системе",
          type: "bool",
        },
        description: {
          title: "Метка 'Описание'",
          type: "enum",
          resource: "shipping-descriptions",
        },
        fragile: {
          title: "Хрупкий",
          type: "bool",
        },
        mesurable: {
          title: "Обмер груза",
          type: "enum",
          resource: "shipping-mesurables",
        },
        weightNetto: {
          title: "Вес нетто",
          type: "decimal",
        },
        weightBrutto: {
          title: "Вес брутто",
          type: "decimal",
        },
        volume: {
          title: "Объем",
          type: "decimal",
        },
        article: {
          title: "Артикул",
          type: "reference",
          resource: "articles",
        },
        categoryInfoCargoPlaces: {
          title: "Количество мест",
          type: "decimal",
        },
      },
    };
  },
  methods: {
    getRowColor(item) {
      if (
        item.ShippingState.Id === eShippingStates.NotAccepted ||
        item.ShippingState.Id === eShippingStates.CanceledByClient
      ) {
        return "grey--text";
      } else {
        return "";
      }
    },
  },
};
</script>
